var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Message - Bold 24px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Message"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Message_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5866 4C24.3746 4 26.0946 4.70667 27.36 5.97467C28.6266 7.24 29.3346 8.94667 29.3346 10.7333V21.2667C29.3346 24.9867 26.308 28 22.5866 28H9.41464C5.6933 28 2.66797 24.9867 2.66797 21.2667V10.7333C2.66797 7.01333 5.67997 4 9.41464 4H22.5866ZM24.708 12.72L24.8146 12.6133C25.1333 12.2267 25.1333 11.6667 24.8 11.28C24.6146 11.0813 24.36 10.96 24.0946 10.9333C23.8146 10.9187 23.548 11.0133 23.3466 11.2L17.3346 16C16.5613 16.6413 15.4533 16.6413 14.668 16L8.66797 11.2C8.2533 10.8933 7.67997 10.9333 7.33464 11.2933C6.97464 11.6533 6.93464 12.2267 7.23997 12.6267L7.41464 12.8L13.4813 17.5333C14.228 18.12 15.1333 18.44 16.0813 18.44C17.0266 18.44 17.948 18.12 18.6933 17.5333L24.708 12.72Z",
    fill: "#21E786"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail2);
export default __webpack_public_path__ + "static/media/email-2.13ef6977ba156dd1b0d14ff6e3893573.svg";
export { ForwardRef as ReactComponent };